var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWindows = function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 4.969 5.724-.758v5.507H3v-4.75Zm5.724 5.368v5.507L3 15.066v-4.763l5.724.034Zm.69-6.236L17 3v6.635l-7.586.069V4.101ZM17 10.392V17l-7.586-1.067V10.38l7.586.013Z",
    fill: "currentColor"
  })));
};

export { SvgWindows as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgNC45Njg1M0w4LjcyNDE0IDQuMjExNDFWOS43MTc4SDNWNC45Njg1M1pNOC43MjQxNCAxMC4zMzczVjE1Ljg0MzdMMyAxNS4wNjU5VjEwLjMwMjlMOC43MjQxNCAxMC4zMzczWk05LjQxMzc5IDQuMTAxMjhMMTcgM1Y5LjYzNTJMOS40MTM3OSA5LjcwNDAzVjQuMTAxMjhaTTE3IDEwLjM5MjNWMTdMOS40MTM3OSAxNS45MzMxVjEwLjM3ODZMMTcgMTAuMzkyM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";